import { Box, Center, List, Stack, Text, Title } from '@mantine/core';
import { IconMail } from '@tabler/icons-react';
import { AuthCard } from 'src/auth/components/AuthCard';
import { useIsMobile } from 'src/common/hooks/useIsMobile';
import { LogoWithIcon } from 'src/UI/app-container/header/Header';

export const AccountDeletionPage = () => {
  const { isMobile } = useIsMobile();

  return (
    <Center bg="gray.10" mih="100vh" py={'md'}>
      <AuthCard w={isMobile ? '100%' : '80%'}>
        <Stack gap="lg">
          <Box mb="md">
            <LogoWithIcon textColor="gray.10" />
          </Box>

          <Title order={2} size="h3">
            Account Deletion Request
          </Title>

          <Text c="gray.7">
            To request the deletion of your Afternoon account and associated data, please follow
            these steps:
          </Text>

          <Box>
            <Title order={3} size="h5" mb="sm">
              How to Request Account Deletion
            </Title>
            <List spacing="sm" c="gray.7">
              <List.Item>
                Send an email to{' '}
                <Text component="a" href="mailto:support@afternoon.co.uk" c="blue.6" fw={500}>
                  support@afternoon.co.uk
                </Text>
              </List.Item>
              <List.Item>{'Include "Account Deletion Request" in the subject line'}</List.Item>
              <List.Item>Provide the email address associated with your account</List.Item>
              <List.Item>
                Our support team will process your request and confirm when the deletion is complete
              </List.Item>
            </List>
          </Box>

          <Box>
            <Title order={3} size="h5" mb="sm">
              What Data Will Be Deleted
            </Title>
            <Text c="gray.7" mb="sm">
              When you request account deletion, all of your personal data and associated
              information will be permanently deleted from our systems, including:
            </Text>
            <List spacing="xs" c="gray.7">
              <List.Item>Account profile information</List.Item>
              <List.Item>Client data and financial records</List.Item>
              <List.Item>Documents and uploaded files</List.Item>
              <List.Item>Meeting recordings and notes</List.Item>
              <List.Item>All other data associated with your account</List.Item>
            </List>
          </Box>

          <Box>
            <Title order={3} size="h5" mb="sm">
              Data Retention for Compliance
            </Title>
            <Text c="gray.7">
              In some cases, we may be legally required to retain certain data for compliance
              purposes (such as financial regulations, tax requirements, or legal obligations). If
              this applies to your account, we will inform you of:
            </Text>
            <List spacing="xs" c="gray.7" mt="sm">
              <List.Item>The specific data that must be retained</List.Item>
              <List.Item>The legal basis for retention</List.Item>
              <List.Item>The retention period required</List.Item>
            </List>
          </Box>

          <Box p="md" bg="blue.0" style={{ borderRadius: '8px' }} mt="md">
            <Stack gap="xs">
              <Box
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                <IconMail size={20} color="var(--mantine-color-blue-6)" />
                <Text fw={600} c="blue.8">
                  Contact Us
                </Text>
              </Box>
              <Text size="sm" c="gray.7">
                Email:{' '}
                <Text component="a" href="mailto:support@afternoon.co.uk" c="blue.6" fw={500}>
                  support@afternoon.co.uk
                </Text>
              </Text>
              <Text size="sm" c="gray.6">
                We typically respond to deletion requests within 1-3 business days.
              </Text>
            </Stack>
          </Box>
        </Stack>
      </AuthCard>
    </Center>
  );
};
